import React, { useState, useEffect } from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Tooltip, useTheme } from '@mui/material';

const STORAGE_KEY = 'quran_progress_mode';

const ProgressModeToggle = ({ value, onChange }) => {
  const theme = useTheme();
  const [mode, setMode] = useState(value || 'verses');

  // Load preference from localStorage on mount
  useEffect(() => {
    const savedMode = localStorage.getItem(STORAGE_KEY);
    if (savedMode && (savedMode === 'verses' || savedMode === 'pages')) {
      setMode(savedMode);
      if (onChange) {
        onChange(null, savedMode);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      setMode(newValue);
      localStorage.setItem(STORAGE_KEY, newValue);
      if (onChange) {
        onChange(event, newValue);
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 0 }}>
      <ToggleButtonGroup
        value={value || mode}
        exclusive
        onChange={handleChange}
        aria-label="progress mode"
        size="small"
        color="primary"
        sx={{
          '& .MuiToggleButton-root': {
            transition: 'all 0.2s ease',
            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
            },
          },
        }}
      >
        <Tooltip title="Calculate progress by number of verses completed">
          <ToggleButton value="verses" aria-label="Verses">
            Verses
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Calculate progress by number of pages completed">
          <ToggleButton value="pages" aria-label="Pages">
            Pages
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ProgressModeToggle;

